import React, { useState } from 'react';
import s from './SalonFilter.module.scss';

const Switcher = ({ setIsAvailable, isAvailable }) => {

    const handleToggle = () => {
        setIsAvailable(!isAvailable);
    };

    return (
        <div className={s.switcher}>
            <input
                type="checkbox"
                id="toggle"
                className={s.switcher__input}
                checked={isAvailable}
                onChange={handleToggle}
            />
            <label htmlFor="toggle" className={s.switcher__label}></label>
            <span className={s.switcher__text}>Available now</span>
        </div>
    );
};

export default Switcher;
